import { render, staticRenderFns } from "./markMonitor.vue?vue&type=template&id=f488a12a"
import script from "./markMonitor.vue?vue&type=script&lang=js"
export * from "./markMonitor.vue?vue&type=script&lang=js"
import style0 from "./markMonitor.vue?vue&type=style&index=0&id=f488a12a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports